// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__39akj","badge__text":"Badge_badge__text__2Ve5g","badge_full":"Badge_badge_full__1xIl-"};